import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { useDeviceMutation } from '@/hooks/useDeviceMutation';
import { SectionHeader, Field } from './SectionHeader';
import type { DeviceStatus } from '@/lib/types';

interface Props { device: DeviceStatus; disabled: boolean }

export function FlowHwSection({ device, disabled }: Props) {
  const f = device.flowHw;
  const [gpioPin,     setGpioPin]     = useState<number>(f?.gpioPin     ?? 35);
  const [startDelay,  setStartDelay]  = useState<number>(f?.startDelay  ?? 5000);
  const [monitorTime, setMonitorTime] = useState<number>(f?.monitorTime ?? 4000);

  useEffect(() => { if (device.flowHw?.gpioPin     !== undefined) setGpioPin(device.flowHw.gpioPin); },         [device.flowHw?.gpioPin]);
  useEffect(() => { if (device.flowHw?.startDelay  !== undefined) setStartDelay(device.flowHw.startDelay); },   [device.flowHw?.startDelay]);
  useEffect(() => { if (device.flowHw?.monitorTime !== undefined) setMonitorTime(device.flowHw.monitorTime); }, [device.flowHw?.monitorTime]);

  const mut = useDeviceMutation<{ gpioPin: number; startDelay: number; monitorTime: number }>(
    device.client_id, 'flow-hw', { successToast: 'Flow sensor saved' },
  );

  return (
    <div className="space-y-5">
      <SectionHeader title="Flow sensor hardware"
        description="Pin the flow sensor is wired to, plus the timing window used to detect dry-running." />
      <div className="grid grid-cols-3 gap-3">
        <Field label="GPIO pin">
          <Input type="number" min={0} max={39} value={gpioPin} disabled={disabled}
            onChange={(e) => setGpioPin(parseInt(e.target.value || '0', 10))} />
        </Field>
        <Field label="Start delay (ms)">
          <Input type="number" min={0} value={startDelay} disabled={disabled}
            onChange={(e) => setStartDelay(parseInt(e.target.value || '0', 10))} />
        </Field>
        <Field label="Monitor time (ms)">
          <Input type="number" min={0} value={monitorTime} disabled={disabled}
            onChange={(e) => setMonitorTime(parseInt(e.target.value || '0', 10))} />
        </Field>
      </div>
      <Button
        onClick={() => mut.mutate({ gpioPin, startDelay, monitorTime })}
        loading={mut.isPending} disabled={disabled || mut.isPending}
      >
        Save flow config
      </Button>
    </div>
  );
}
